const SelectedTabActionTypes = {
  SET_CUSTOMER_LIST_TAB: 'SET_CUSTOMER_LIST_TAB',
  SET_CUSTOMER_INFORMATION_TAB: 'SET_CUSTOMER_INFORMATION_TAB',
  SET_PRINT_CD_STATUS_TAB: 'SET_PRINT_CD_STATUS_TAB',
  SET_PRINT_MESSENGER_ORDER_STATUS_TAB: 'SET_PRINT_MESSENGER_ORDER_STATUS_TAB',
  SET_PRINT_VOUCHER_STATUS_TAB: 'SET_PRINT_VOUCHER_STATUS_TAB',
  SET_PRINT_CHEQUE_STATUS_TAB: 'SET_PRINT_CHEQUE_STATUS_TAB',
  SET_MESSENGER_ORDER_PREVIEW_TYPE_TAB: 'SET_MESSENGER_ORDER_PREVIEW_TYPE_TAB',
  SET_APPROVAL_TYPE_TAB: 'SET_APPROVAL_TYPE_TAB',
  SET_APPROVAL_CIF_INFO_TYPE_TAB: 'SET_APPROVAL_CIF_INFO_TYPE_TAB',
  SET_APPROVAL_CUSTOMER_TYPE_TAB: 'SET_APPROVAL_CUSTOMER_TYPE_TAB',
  SET_CD_STATUS_TYPE_TAB: 'SET_CD_STATUS_TYPE_TAB',
  SET_PAYMENT_APPROVAL_STATUS_TABS: 'SET_PAYMENT_APPROVAL_STATUS_TABS',
  SET_NEARLY_DUE_STATUS_TAB: 'SET_NEARLY_DUE_STATUS_TAB',
  SET_RETURN_CD_STATUS_TAB: 'SET_RETURN_CD_STATUS_TAB',
  SET_WITHDRAW_APPROVAL_STATUS_TAB: 'SET_WITHDRAW_APPROVAL_STATUS_TAB',
  SET_RETURN_CHEQUE_STATUS_TAB: 'SET_RETURN_CHEQUE_STATUS_TAB'
};

export default SelectedTabActionTypes;
